"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiCloseGlyph = {
    paths: [
        {
            path: 'M6.58578644,8.50200475 L0.292893219,14.794898 C-0.0976310729,15.1854223 -0.0976310729,15.8185872 0.292893219,16.2091115 C0.683417511,16.5996358 1.31658249,16.5996358 1.70710678,16.2091115 L8,9.91621832 L14.2928932,16.2091115 C14.6834175,16.5996358 15.3165825,16.5996358 15.7071068,16.2091115 C16.0976311,15.8185872 16.0976311,15.1854223 15.7071068,14.794898 L9.41421356,8.50200475 L15.7071068,2.20911154 C16.0976311,1.81858724 16.0976311,1.18542227 15.7071068,0.794897973 C15.3165825,0.404373682 14.6834175,0.404373682 14.2928932,0.794897973 L8,7.08779119 L1.70710678,0.794897973 C1.31658249,0.404373682 0.683417511,0.404373682 0.292893219,0.794897973 C-0.0976310729,1.18542227 -0.0976310729,1.81858724 0.292893219,2.20911154 L6.58578644,8.50200475 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Close',
    width: 16,
    height: 17,
};
var muiClose = {
    base: muiCloseGlyph,
};
exports.muiClose = muiClose;
//# sourceMappingURL=close.js.map